// in src/posts.js
import * as React from "react";
import { Show as RaShow, SimpleShowLayout, TextField } from "react-admin";
import { useFormStyles } from "../components/forms/useStyles";
import Title from "../components/Title";

const Show = (props) => {
	const classes = useFormStyles();
	return (
		<RaShow title={<Title source="csv_name" />} {...props} classes={classes}>
			<SimpleShowLayout>
				<TextField source="notes" type="textarea" />
			</SimpleShowLayout>
		</RaShow>
	);
};

export default Show;
